
<div class="alert alert-warning" role="alert" [style.display]="hiddenMsg? 'none': 'block'">
    {{message}}
</div>